import config from '../config/index'
import { request } from '../request'
import { ITransitLine } from '../share-types'

const { mainApi } = config

export const getTransitLinesByCityId = (cityId: number) =>
  request.get<MISSING_TYPE, ITransitLine[]>(`${mainApi}/transit-lines`, { params: { cityId } })
